import { defineMessages } from '@cookbook/solid-intl'

// Split out of `ontario-vacation-rentals-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'List your property in Ontario. Earn more from your rental with lower fees and more control than traditional platforms.',
        id: 'OntarioVacationRentalsPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Ontario Vacation Rentals | Lodgr',
        id: 'OntarioVacationRentalsPage.titleMessage',
    }),
}
